import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Enveloppe = withDefaultIconProps(
  {
    height: 30,
    width: 30,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 30 30">
      <Path
        d="M5.5 22.78H24.5C25.48 22.78 26.28 21.98 26.28 21V9C26.28 8.02 25.48 7.22 24.5 7.22H5.5C4.52 7.22 3.72 8.02 3.72 9V21C3.72 21.98 4.52 22.78 5.5 22.78ZM24.5 21.25H5.5C5.36 21.25 5.25 21.14 5.25 21V9.95L14.55 16.62C14.69 16.72 14.84 16.76 15 16.76C15.16 16.76 15.31 16.72 15.44 16.62L24.75 9.95V21C24.75 21.14 24.64 21.25 24.5 21.25ZM6.2 8.75H23.8L15 15.06L6.2 8.75Z"
        fill={color}
      />
    </Svg>
  ),
);
